import React from 'react';
import { Heart, Cake, Building, Church, GraduationCap, PartyPopper } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Heart,
  Cake,
  Building,
  Church,
  GraduationCap,
  PartyPopper
};

const Services = () => {
  return (
    <section id="services" className="py-32 bg-[#000000] relative overflow-hidden">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #D4AF37 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Decorative Lines */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-400/20 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-gold-400 text-xs font-medium tracking-[0.3em] uppercase mb-6 block">
            Šta nudimo
          </span>
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-light text-gold-400 mb-6">
            Naše <span className="text-gold-gradient">usluge</span>
          </h2>
          <div className="w-16 h-[1px] bg-gold-400 mx-auto mb-8" />
          <p className="text-white/50 max-w-2xl mx-auto text-lg font-light">
            Bilo da planirate svadbu iz snova, nezaboravan rođendan ili korporativni event, 
            mi smo tu da vašu proslavu učinimo posebnom.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="luxury-card group relative bg-white/[0.02] border border-white/5 p-10 hover:border-gold-400/30 transition-all duration-500"
              >
                {/* Corner Accent */}
                <div className="absolute top-0 left-0 w-8 h-[1px] bg-gold-400/50 transition-all duration-500 group-hover:w-16" />
                <div className="absolute top-0 left-0 w-[1px] h-8 bg-gold-400/50 transition-all duration-500 group-hover:h-16" />
                
                {/* Icon */}
                <div className="w-12 h-12 border border-gold-400/30 flex items-center justify-center mb-8 group-hover:border-gold-400/60 transition-colors duration-300">
                  {IconComponent && <IconComponent className="w-5 h-5 text-gold-400" />}
                </div>

                {/* Content */}
                <h3 className="text-xl font-light text-white mb-4 tracking-wide group-hover:text-gold-400 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-white/50 leading-relaxed font-light text-sm">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
